import format from "string-template";
import { REGEX_EXPS } from "utils/constants";
import * as yup from "yup";

const validation = (messages) => {
  return yup.object().shape({
    project: yup.object().shape({
      fields: yup.object().shape({
        acceptProductStatuses: yup
          .boolean()
          .required(messages.REQUIRED)
          .oneOf([true], messages.REQUIRED),
        acceptFees: yup
          .boolean()
          .required(messages.REQUIRED)
          .oneOf([true], messages.REQUIRED),
        acceptAgreement: yup
          .boolean()
          .required(messages.REQUIRED)
          .oneOf([true], messages.REQUIRED),
      }),
    }),
    additionalInfo: yup.object().shape({
      referralCode: yup
        .string()
        .typeError(messages.NOT_STRING)
        .nullable()
        .notRequired()
        .test(
          "isValid",
          format(messages.INVALID_REFERRAL_CODE, { length: 6 }),
          function (value) {
            return value
              ? new RegExp(REGEX_EXPS.referralCode).test(
                  value.replace(/\s+/g, ""),
                )
              : true;
          },
        ),
    }),
  });
};

export default validation;
